import React from "react";
import { useSelector } from "react-redux";

const Radio = ({
    label,
    value,
    checked,
    onChange = () => {},
    name,
    size = 16,
    gap = 8,
    markType = false,
    textColor = "black",
}) => {
    const { primaryBackground } = useSelector((state) => state.dynamicStore);


    const containerStyle = {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        fontSize: `${size}px`,
        userSelect: "none",
    };

    const checkmarkStyle = {
        position: "relative",
        flexShrink: 0,
        width: `24px`,
        height: `24px`,
        borderRadius: "50%",
        backgroundColor: "rgba(186, 186, 186, 1)",
        marginRight: `${gap}px`, // Adjust this spacing as needed
    };

    const checkmarkAfterStyle = {
        content: '""',
        position: "absolute",
        display: checked ? "block" : "none",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "14px",
        height: "14px",
        borderRadius: "50%",
        background: primaryBackground,
    };

    const checkmarkBeforeStyle = {
        content: '""',
        position: "absolute",
        display: !checked ? "block" : "none",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "14px",
        height: "14px",
        borderRadius: "50%",
        background: "white",
    };

    return (
        <label style={containerStyle}>
            {
                <>
                    <input
                        type="radio"
                        checked={checked}
                        onChange={onChange}
                        value={value}
                        name={name}
                        style={{ display: "none" }}
                    />
                    <span style={checkmarkStyle}>
                        <span
                            style={
                                checked
                                    ? checkmarkAfterStyle
                                    : checkmarkBeforeStyle
                            }
                        ></span>
                    </span>
                    <span style={{ color: textColor, fontWeight: 600 }}>
                        {label}
                    </span>
                </>
            }
        </label>
    );
};

export default Radio;
